/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        20/02/2020      2696:Facility Done Page
*********************************************************************************/
import { withState } from "@mna/react";
import AnimationThankYou2 from "features/Animation/ThankYou2";
import { Trans } from "react-i18next";
import LoadingScreen from "features/LoadingScreen";
import { careOptions, commonConstant } from "../../../server/triage/constants";
import { generateJsonWebToken, checkAndGetLocalStorageValue, checkAndGetSessionStorageValue } from "../../../features/utils";
let isComingFromDeclineCare = false;

const Done = ({ state, setState, actions, history }) => (
  <div className="article-width align-item flex flex-column full-height pt-2">
    <LoadingScreen isLoading={state.isLoading}>
      <h1 className="text-center standby-page-header-title">
        {(state.triageRequest.selectedCareOptionName ==
            careOptions.DeclineCare ||
            state.triageRequest.selectedCareOptionName ==
            careOptions.ExitTriage ||
            state.isWhatsNext == false) ? (
          <Trans i18nKey="findcareoption.Careoptions.Done.DoneScreenDeclineCareTitle"></Trans>
        ) : (
          state.triageRequest.selectedCareOptionName === careOptions.Telemedicine || state.triageRequest.selectedCareOptionName === careOptions.EmergencyRoom ?
            <Trans i18nKey="findcareoption.Careoptions.Done.DoneScreenTitleTeleEmer">
              Thank you for using Directional Care; here are the next steps and the FAQ.
            </Trans> :
            <Trans i18nKey="findcareoption.Careoptions.Done.DoneScreenTitle">
              What's next for using StandbyMD
            </Trans>
        )}
      </h1>

      <div className="standby-col standby-center">
        <AnimationThankYou2 />
      </div>

      <div>
        <p
          className="standby-justify"
          dangerouslySetInnerHTML={{
            __html: state.isWhatsNext
              ? state.whatsNextContent
              : state.ThankYouContent,
          }}
        />
      </div>


      {state.isWhatsNext && state.triageRequest.selectedCareOptionName !==
        careOptions.DeclineCare ? (<div>
          <p
            className="standby-justify"
            dangerouslySetInnerHTML={{
              __html: state.userInstruction
              ,
            }}
          />
        </div>) : ""}

      <div className="done-space">
        {/*CHID-1  Start*/}
        {/*CHID-1  Start*/}
        <button
          type="button"
          className="button standby-button standby-button-gradient standby-button-gradient-green"
          onClick={(e) => {
            gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
            if (state.IsValidUser) {
              if (state.isWhatsNext) {
                setState({
                  isWhatsNext: false,
                  isMenuClick: false,
                  declineCare: false,
                });
                e.preventDefault();
                actions.submitTriageSession();
                history.push("/find-care-options/thank-you");
              } else history.push("/terms");
            } else {
              e.currentTarget.setAttribute("class", "hide");
              e.preventDefault();
              actions.submitTriageSession();
              sessionStorage.removeItem("locationScreen");
              setState({
                LocationScreen: false
              })
              setState({ isMenuClick: false, declineCare: false })
              sessionStorage.setItem("IsValidUser", false);
              if (isComingFromDeclineCare) {
                history.push("/terms");
              } else {
                history.push("/find-care-options/thank-you");
              }
            }
          }}
        >
          {(state.triageRequest.selectedCareOptionName ==
              careOptions.DeclineCare ||
              state.triageRequest.selectedCareOptionName ==
              careOptions.ExitTriage || isComingFromDeclineCare) ? (
            <Trans i18nKey="findcareoption.Careoptions.Done.startTriage">
              Start Triage
            </Trans>
          ) : (
            <Trans i18nKey="findcareoption.Careoptions.Done.done">DONE</Trans>
          )}
        </button>
      </div>
    </LoadingScreen>
  </div>
);
export default withState({
  async didMount({ state, actions, setState }) {
    var currentQueryString = window.location.search;
    if (currentQueryString) {
      isComingFromDeclineCare = true;
    } else {
      isComingFromDeclineCare = false;
    }
    window.store = store;
    if ((state.IsValidUser === undefined || !state.IsValidUser) && !state.isFacility && !state.triageRequest.isFacilitySearch) {
      setState({
        isTriageGoingForRegularUser: false,
      });
    }
    if (state.triageRequest.selectedCareOptionName == careOptions.ExitTriage) {
      setState({
        isWhatsNext: false,
      });
    } else {
      setState({
        isWhatsNext: true,
      });
    }
    var data = actions.getReferenceData(state, setState, false, false);

    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    // var command = "search/speciality" + data;

    // var response = await actions.getNodeCallBack(
    //   state,
    //   setState,
    //   actions,
    //   command
    // );
    var action = "getReferenceText";
    var response = await actions.sendTriageRequest({
    action: action,
    data: ({...data,  jwtAccessToken: jwtAccess_Token, accessToken: access_Token}),
  });
    if (response && response.message === commonConstant.success) {
      setState({
        isLoading: false,
        whatsNextContent:
          response.response,
      });
    } else {
      setState({
        isLoading: false,
        whatsNextContent: "",
      });
    }
    var userInstructionData = actions.getReferenceData(state, setState, false, true);
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");

    // var command = "search/speciality" + userInstructionData;
    // var response = await actions.getNodeCallBack(state, setState, actions, command);
    var action = "getReferenceText";
    var response = await actions.sendTriageRequest({
    action: action,
    data: ({...userInstructionData,  jwtAccessToken: jwtAccess_Token, accessToken: access_Token}),
  });
    if (response && response.message === commonConstant.success) {
      setState({
        isLoading: false,
        userInstruction:
          response.response,
      });
    } else {
      setState({
        isLoading: false,
        whatsNextContent: "",
        userInstruction: "",
      });
    }
    data = actions.getReferenceData(state, setState, true, false);
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    // command = "search/speciality" + data;
    // response = await actions.getNodeCallBack(state, setState, actions, command);
    var action = "getReferenceText";
    var response = await actions.sendTriageRequest({
    action: action,
    data: ({...data,  jwtAccessToken: jwtAccess_Token, accessToken: access_Token}),
  });
  if (response && response.message === commonConstant.success)
     {
      setState({
        ThankYouContent:
          response.response,
      });
    } else {
      setState({
        ThankYouContent: "",
      });
    }
    setState({
      isLoading: false,
    });
  },
})(Done);
